import { GetLodgingRequestsCountState, GetLodgingRequestsCountActionTypes, GET_LODGING_REQUESTS_COUNT_DATA_REQUEST, GET_LODGING_REQUESTS_COUNT_DATA_SUCCESS, GET_LODGING_REQUESTS_COUNT_DATA_FAILURE } from "store/reducers/lodgingRequest/get-count/types";

const defaultState: GetLodgingRequestsCountState = {
  isLoading: false,
  errorMessage: ""
};

export default function getLodgingRequestsCount(state = defaultState, action: GetLodgingRequestsCountActionTypes): GetLodgingRequestsCountState {
  switch (action.type) {
    case GET_LODGING_REQUESTS_COUNT_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_LODGING_REQUESTS_COUNT_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_LODGING_REQUESTS_COUNT_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};